const Contact = (): JSX.Element => {
  return <div>Contact Page</div>;
};

export default Contact;
